// Global packages and components
import { ContentEditor, Button, BannerImage } from '~/components'

// Types
import type { BannerSidebarProps } from '~/types'

// Main export
const BannerSidebar = ({ image, content, button }: BannerSidebarProps) => (
  <div className="relative aspect-portrait rounded-2xl">
    {content && (
      <div className="relative z-[2] flex h-full flex-col justify-end rounded-2xl px-6 py-8 text-white">
        <div className="mb-6 last:*:mb-0">
          <ContentEditor content={content} />
        </div>
        {button && (
          <div>
            <Button {...button} />
          </div>
        )}
      </div>
    )}
    <BannerImage
      image={image}
      size={768}
    />
  </div>
)

export default BannerSidebar
